// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"styles_paragraph__39Qv4","paragraph--disabled":"styles_paragraph--disabled__1ulEq","paragraph__editor":"styles_paragraph__editor__FgqRD"};